<template>
    <!-- breadcrumb-area start -->
    <div class="breadcrumb-area gradient--secondary">
        <div class="container">
          <b-navbar-brand :to="{name:'HomeStartUp'}">
            <img :src='"../assets/img/logo/logo-dark.png"' alt="logo">
          </b-navbar-brand>
            <div class="row">
                <div class="col-12">
                    <slot name="breadcrumb"></slot>
                </div>
            </div>
        </div>
    </div>
    <!-- breadcrumb-area end -->
</template>

<script>
    export default {
        name: 'Breadcrumb'
    }
</script>
